import createApiAction from "../../helpers/apiActionCreator";
import * as api from "./user.api";
import {
  IUser,
  IUserList,
  IUpdateUser,
  IExercise,
  IWorkout,
  IUpdateUserIntro
} from "./types";

export const FETCH_USERS = "FETCH_USERS";
export const FETCH_USER = "FETCH_USER";
export const UPDATE_USER = "UPDATE_USER";
export const UPDATE_USER_INTRO = "UPDATE_USER_INTRO";
export const UPDATE_EXERCISE = "UPDATE_EXERCISE";
export const UPDATE_WORKOUT = "UPDATE_WORKOUT";
export const CREATE_WORKOUT = "CREATE_WORKOUT";
export const DELETE_WORKOUT = "DELETE_WORKOUT";
export const UPDATE_CURRENT_WORKOUT = "UPDATE_CURRENT_WORKOUT";
export const CLEAR_CURRENT_WORKOUT = "CLEAR_CURRENT_WORKOUT";
export const UPDATE_CURRENT_EXERCISE = "UPDATE_CURRENT_EXERCISE";

export type FetchUsers = (query?: { search?: string }) => Promise<IUserList[]>;
export function fetchUsers(query?: { search?: string }) {
  return createApiAction(FETCH_USERS, api.getUsers)({ query });
}

export type FetchUser = (id: string) => Promise<IUser | undefined>;
export function fetchUser(id: string) {
  return createApiAction(FETCH_USER, api.getUser)({ userId: id });
}

export type UpdateUser = (id: string, data: IUpdateUser) => Promise<IUser>;
export function updateUser(id: string, data: IUpdateUser) {
  return createApiAction(UPDATE_USER, api.updateUser)({ userId: id, data });
}

export type UpdateUserIntro = (
  userId: string,
  data: IUpdateUserIntro
) => Promise<string>;
export function updateUserIntro(userId: string, data: IUpdateUserIntro) {
  return createApiAction(
    UPDATE_USER_INTRO,
    api.updateUserIntro
  )({ userId, data });
}

export type UpdateExercise = (
  userId: string,
  workoutId: string,
  exerciseId: string,
  data: Partial<IExercise>
) => Promise<IExercise | undefined>;
export function updateExercise(
  userId: string,
  workoutId: string,
  exerciseId: string,
  data: Partial<IExercise>
) {
  return createApiAction(
    UPDATE_EXERCISE,
    api.updateExercise
  )({ userId, workoutId, exerciseId, data });
}

export type UpdateWorkout = (
  userId: string,
  workoutId: string,
  data: Partial<IWorkout>
) => Promise<IWorkout | undefined>;
export function updateWorkout(
  userId: string,
  workoutId: string,
  data: Partial<IWorkout>
) {
  return createApiAction(
    UPDATE_WORKOUT,
    api.updateWorkout
  )({ userId, workoutId, data });
}

export type DeleteWorkout = (
  userId: string,
  workoutId: string
) => Promise<string>;
export function deleteWorkout(userId: string, workoutId: string) {
  return createApiAction(
    DELETE_WORKOUT,
    api.deleteWorkout
  )({ userId, workoutId });
}

export type CreateWorkout = (
  userId: string,
  workout: IWorkout
) => Promise<IWorkout | undefined>;
export function createWorkout(userId: string, workout: IWorkout) {
  return createApiAction(
    CREATE_WORKOUT,
    api.createWorkout
  )({ userId, data: workout });
}

export type UpdateCurrentWorkout = (
  workout: Partial<IWorkout>
) => { type: string; workout: Partial<IWorkout> };
export function updateCurrentWorkout(workout: Partial<IWorkout>) {
  return { type: UPDATE_CURRENT_WORKOUT, workout };
}

export type UpdateCurrentExercise = (
  exerciseId: string,
  exercise: Partial<IExercise>
) => { type: string; exercise: Partial<IExercise> };
export function updateCurrentExercise(
  exerciseId: string,
  exercise: Partial<IExercise>
) {
  return { type: UPDATE_CURRENT_EXERCISE, exercise, exerciseId };
}

export function clearCurrentWorkout() {
  return { type: CLEAR_CURRENT_WORKOUT };
}
